"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uri = void 0;
var tracing_js_1 = require("@web3api/tracing-js");
/**
 * A Web3API URI. Some examples of valid URIs are:
 * w3://ipfs/QmHASH
 * w3://ens/sub.dimain.eth
 * w3://fs/directory/file.txt
 * w3://uns/domain.crypto
 *
 * Breaking down the various parts of the URI, as it applies
 * to [the URI standard](https://tools.ietf.org/html/rfc3986#section-3):
 * **w3://** - URI Scheme: differentiates Web3API URIs.
 * **ipfs/** - URI Authority: allows the Web3API URI resolution algorithm to determine an authoritative URI resolver.
 * **sub.domain.eth** - URI Path: tells the Authority where the API resides.
 */
var Uri = /** @class */ (function () {
    function Uri(uri) {
        this._config = Uri.parseUri(uri);
    }
    Object.defineProperty(Uri.prototype, "authority", {
        get: function () {
            return this._config.authority;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Uri.prototype, "path", {
        get: function () {
            return this._config.path;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Uri.prototype, "uri", {
        get: function () {
            return this._config.uri;
        },
        enumerable: false,
        configurable: true
    });
    Uri.equals = function (a, b) {
        return a.uri === b.uri;
    };
    Uri.isUri = function (value) {
        return typeof value === "object" && value.uri !== undefined;
    };
    Uri.isValidUri = function (uri, parsed) {
        try {
            var result = Uri.parseUri(uri);
            if (parsed) {
                parsed = Object.assign(parsed, result);
            }
            return true;
        }
        catch (e) {
            return false;
        }
    };
    Uri.prototype.toString = function () {
        return this._config.uri;
    };
    Uri.parseUri = function (uri) {
        if (!uri) {
            throw Error("The provided URI is empty");
        }
        var processed = uri;
        // Trim preceding '/' characters
        while (processed[0] === "/") {
            processed = processed.substr(1);
        }
        // Check for the w3:// scheme, add if it isn't there
        var w3SchemeIdx = processed.indexOf("w3://");
        // If it's missing the w3:// scheme, add it
        if (w3SchemeIdx === -1) {
            processed = "w3://" + processed;
        }
        // If the w3:// is not in the beginning, throw an error
        if (w3SchemeIdx > -1 && w3SchemeIdx !== 0) {
            throw Error("The w3:// scheme must be at the beginning of the URI string");
        }
        // Extract the authoriy & path
        var result = processed.match(/w3:\/\/([a-z][a-z0-9-_]+)\/(.*)/);
        // Remove all empty strings
        if (result) {
            result = result.filter(function (str) { return !!str; });
        }
        if (!result || result.length !== 3) {
            throw Error("URI is malformed, here are some examples of valid URIs:\n" +
                "w3://ipfs/QmHASH\n" +
                "w3://ens/domain.eth\n" +
                "ens/domain.eth\n\n" +
                ("Invalid URI Received: " + uri));
        }
        return {
            uri: processed,
            authority: result[1],
            path: result[2],
        };
    };
    __decorate([
        tracing_js_1.Tracer.traceMethod("Uri: parseUri")
    ], Uri, "parseUri", null);
    return Uri;
}());
exports.Uri = Uri;
//# sourceMappingURL=Uri.js.map